export const privacyPolicyPath = '/privacy-policy';

export const privacyPolicyContactEmail = 'hello@getbudgy.co.uk';
